import { render, staticRenderFns } from "./ProductsCategories.vue?vue&type=template&id=d6ad050c&"
import script from "./ProductsCategories.vue?vue&type=script&lang=js&"
export * from "./ProductsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports